module.exports = __webpack_public_path__ + "static/favicon-c57bbe657966ea66752d7398b2b51a55.ico";